// extracted by mini-css-extract-plugin
export default {"container":"ProjectList_container__HfSgu","pagination":"ProjectList_pagination__C2Kw9"};